export default __webpack_public_path__ + "static/media/myPOS.199e3bd2.png";